import { Mail, Phone, MapPin } from 'lucide-react'

const Contact = () => {
  return (
    <div className="bg-gradient-to-b from-gray-50 to-white min-h-screen">
      {/* Hero Section */}
      <section className="bg-gradient-to-r from-primary-600 to-primary-800 text-white py-10">
        <div className="container-custom">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-4xl md:text-5xl font-bold mb-4">
              Contact Us
            </h1>
            <p className="text-xl text-primary-100">
              Get in touch with the Lockridge Forest Swim & Tennis Club
            </p>
          </div>
        </div>
      </section>

      {/* Contact Information */}
      <section className="py-10">
        <div className="container-custom max-w-4xl">
          <div className="grid md:grid-cols-3 gap-8 mb-10">
            {/* Email */}
            <div className="text-center">
              <div className="inline-flex items-center justify-center w-16 h-16 bg-primary-100 rounded-full mb-4">
                <Mail className="w-8 h-8 text-primary-600" />
              </div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">Email Us</h3>
              <a
                href="mailto:admin@lockridgeforestswimtennis.com"
                className="text-blue-600 hover:text-blue-800 transition-colors"
              >
                admin@lockridgeforestswimtennis.com
              </a>
            </div>

            {/* Phone */}
            <div className="text-center">
              <div className="inline-flex items-center justify-center w-16 h-16 bg-secondary-100 rounded-full mb-4">
                <Phone className="w-8 h-8 text-secondary-600" />
              </div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">Call or Text</h3>
              <a
                href="tel:7706097428"
                className="text-blue-600 hover:text-blue-800 transition-colors"
              >
                (770) 609-7428
              </a>
              <p className="text-sm text-gray-600 mt-1">Text or leave voicemail</p>
            </div>

            {/* Address */}
            <div className="text-center">
              <div className="inline-flex items-center justify-center w-16 h-16 bg-tertiary-100 rounded-full mb-4">
                <MapPin className="w-8 h-8 text-tertiary-600" />
              </div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">Visit Us</h3>
              <p className="text-gray-700">
                3154 Sumac Drive<br />
                Peachtree Corners, GA 30360
              </p>
            </div>
          </div>

          {/* Map */}
          <div className="bg-white rounded-xl shadow-lg overflow-hidden mb-10">
            <iframe
              title="Lockridge Forest Swim & Tennis Club Location"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3307.8823!2d-84.1836!3d33.9726!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x88f5a4d6e7c8b9a3%3A0x1234567890abcdef!2s3154%20Sumac%20Dr%2C%20Peachtree%20Corners%2C%20GA%2030360!5e0!3m2!1sen!2sus!4v1234567890123!5m2!1sen!2sus"
              width="100%"
              height="450"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>

          {/* Board of Directors */}
          <div className="bg-primary-50 border border-primary-200 rounded-xl p-8">
            <h2 className="text-2xl font-bold text-gray-900 mb-4 text-center">
              Contact the Board of Directors
            </h2>
            <p className="text-gray-700 text-center mb-6">
              For questions regarding membership, rules, events, or general club matters,
              please reach out to our Board of Directors.
            </p>
            <div className="text-center">
              <a
                href="mailto:admin@lockridgeforestswimtennis.com"
                className="inline-block px-8 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 font-medium transition-colors"
              >
                Email Board of Directors
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div className="mt-10 grid md:grid-cols-2 gap-6">
            <div className="bg-white rounded-lg shadow-md p-6">
              <h3 className="text-xl font-semibold text-gray-900 mb-3">Membership Inquiries</h3>
              <p className="text-gray-600 mb-4">
                Interested in becoming a member? Learn about our membership options and benefits.
              </p>
              <a
                href="/membership"
                className="text-blue-600 hover:text-blue-800 font-medium"
              >
                View Membership Options →
              </a>
            </div>

            <div className="bg-white rounded-lg shadow-md p-6">
              <h3 className="text-xl font-semibold text-gray-900 mb-3">Facility Reservations</h3>
              <p className="text-gray-600 mb-4">
                Want to reserve our pavilion or Taj Mahal for your event?
              </p>
              <a
                href="/facility-reservation"
                className="text-blue-600 hover:text-blue-800 font-medium"
              >
                Reserve a Facility →
              </a>
            </div>
          </div>

          {/* Social Media */}
          <div className="mt-10 text-center">
            <h3 className="text-xl font-semibold text-gray-900 mb-4">Connect With Us</h3>
            <a
              href="https://www.facebook.com/groups/lockridgeforest"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
            >
              <svg className="w-5 h-5 mr-2" fill="currentColor" viewBox="0 0 24 24">
                <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
              </svg>
              Join our Facebook Group
            </a>
          </div>
        </div>
      </section>
    </div>
  )
}

export default Contact
